'use client'

import { clearCookieConsent } from '@/lib/cookie-consent'
import { disableGa4AndClearCookies } from '@/lib/ga4-runtime'

export function CookieResetLink() {
  function reset() {
    disableGa4AndClearCookies()
    clearCookieConsent(window.localStorage)
    window.location.reload()
  }

  return (
    <button
      type="button"
      onClick={reset}
      className="text-sm transition-all duration-200 hover:text-white hover:translate-x-0.5 inline-block text-left"
      style={{ color: 'rgba(255,255,255,0.65)', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
    >
      Ustawienia cookies
    </button>
  )
}
